import { AtomEffect } from 'recoil'

export const localStorageEffect: <T>(key: string) => AtomEffect<T> =
  (key: string) =>
  ({ setSelf, onSet }) => {
    if (typeof window === 'undefined') return
    const savedValue = localStorage.getItem(key)
    if (savedValue != null && savedValue !== '' && savedValue !== ' ') {
      setSelf(JSON.parse(savedValue))
    }
    onSet((newValue, _, isReset) => {
      return isReset ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(newValue))
    })
  }
